import React from 'react';
import { Link } from 'react-router-dom';
import './ServicePage.css';
import medicalImage from '../../assets/services/medical.jpg';
import { FaHospital, FaWheelchair, FaUserNurse, FaCarAlt } from 'react-icons/fa';

function TransportMedical() {
  const features = [
    {
      icon: <FaHospital />,
      title: "Rendez-vous Médicaux",
      description: "Transport pour tous types de rendez-vous médicaux et hospitaliers"
    },
    {
      icon: <FaWheelchair />,
      title: "Équipement Adapté",
      description: "Véhicules équipés pour le transport de personnes à mobilité réduite"
    },
    {
      icon: <FaUserNurse />,
      title: "Personnel Formé",
      description: "Chauffeurs formés aux besoins médicaux spécifiques"
    },
    {
      icon: <FaCarAlt />,
      title: "Confort Maximum",
      description: "Véhicules confortables et adaptés aux besoins médicaux"
    }
  ];

  return (
    <main className="service-page">
      {/* Hero Section */}
      <section className="service-hero" style={{ backgroundImage: `url(${medicalImage})` }}>
        <div className="service-hero-overlay"></div>
        <div className="service-hero-content">
          <h1>Transport Médical</h1>
          <p>Transport adapté pour vos rendez-vous médicaux</p>
        </div>
      </section>

      {/* Main Content */}
      <section className="service-content">
        <div className="service-container">
          {/* Description */}
          <div className="service-description">
            <h2>Service de Transport Médical Spécialisé</h2>
            <p>
              Notre service de transport médical est conçu pour répondre aux besoins 
              spécifiques des personnes nécessitant des soins médicaux. Nous assurons 
              vos déplacements vers les hôpitaux, cliniques et cabinets médicaux en 
              toute sécurité et confort.
            </p>
            <p>
              Nos chauffeurs sont spécialement formés pour accompagner les personnes 
              ayant des besoins médicaux particuliers. Nous disposons de véhicules 
              adaptés et équipés pour garantir votre confort et votre sécurité tout 
              au long du trajet.
            </p>
          </div>

          {/* Features Grid */}
          <div className="service-features">
            {features.map((feature, index) => (
              <div key={index} className="service-feature-card">
                <div className="feature-icon">{feature.icon}</div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>

          {/* Call to Action */}
          <div className="service-cta">
            <h2>Réservez Votre Transport Médical</h2>
            <p>
              Contactez-nous pour organiser votre transport médical en toute tranquillité.
            </p>
            <div className="cta-buttons">
              <a href="tel:+41797774444" className="cta-button secondary">
                +41 79 777 44 44
              </a>
              <Link to="/quote" className="cta-button primary">
                Demander un Devis
              </Link>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default TransportMedical; 